require("app/theme/styles/buttons/IconButton--app-header-dropdown-alt.less");
require("app/theme/styles/buttons/IconButton--app-header-dropdown.less");
require("app/theme/styles/buttons/IconButton--app-header-ghost-green.less");
require("app/theme/styles/buttons/IconButton--app-header-ghost-pink.less");
require("app/theme/styles/buttons/IconButton--app-header-ghost-white.less");
require("app/theme/styles/buttons/IconButton--app-header-icon.less");
require("app/theme/styles/buttons/IconButton--app-header.less");
require("app/theme/styles/buttons/IconButton--close-popup-white.less");
require("app/theme/styles/buttons/IconButton--ghost-green-round-large.less");
require("app/theme/styles/buttons/IconButton--ghost-pink.less");
require("app/theme/styles/buttons/IconButton--ghost-tab-white.less");
require("app/theme/styles/buttons/IconButton--ghost-white.less");
require("app/theme/styles/buttons/IconButton--icon-white-darker.less");
require("app/theme/styles/buttons/IconButton--icon-white.less");
require("app/theme/styles/buttons/IconButton--input-white.less");
require("app/theme/styles/buttons/IconButton--play-icon-overlay-white.less");
require("app/theme/styles/buttons/IconButton--social.less");
require("app/theme/styles/buttons/IconButtonAnimations.less");

module.exports = {

    // App Header
    // --------------------------------

    "app.AppHeader.HeaderView.backButton":                 "app-header-icon",
    "app.AppHeader.HeaderView.previewModeButton":          "app-header-ghost-pink",
    "app.AppHeader.HeaderView.searchButton":               "app-header",
    "app.AppHeader.HeaderView.playlistsButton":            "app-header",
    "app.AppHeader.HeaderView.bookmarksButton":            "app-header",
    "app.AppHeader.HeaderView.genresButton":               "app-header",
    "app.AppHeader.HeaderView.artistsButton":              "app-header",
    "app.AppHeader.HeaderView.CategoryDropdown.activator": "app-header",
    "app.AppHeader.HeaderView.BrandDropdown.activator":    "app-header",
    "app.AppHeader.HeaderView.loginButton":                "app-header-ghost-white",
    "app.AppHeader.HeaderView.signUpButton":               "app-header-ghost-green",

    "app.AppHeader.CategoryDropdown.menuButton": "app-header-dropdown-alt",
    "app.AppHeader.BrandDropdown.menuButton":    "app-header-dropdown-alt",

    "app.AppHeader.LanguageSwitcher.Activator":  "app-header-icon",
    "app.AppHeader.LanguageSwitcher.menuButton": "app-header-dropdown-alt",

    "app.AppHeader.MenuDropdown.Activator":                  "app-header-icon",
    "app.AppHeader.MenuDropdown.previewModeButton":          "app-header-ghost-pink",
    "app.AppHeader.MenuDropdown.homeButton":                 "app-header-dropdown",
    "app.AppHeader.MenuDropdown.signUpButton":               "app-header-ghost-green",
    "app.AppHeader.MenuDropdown.loginButton":                "app-header-ghost-white",
    "app.AppHeader.MenuDropdown.addToHomeScreenButton":      "app-header-dropdown",
    "app.AppHeader.MenuDropdown.searchButton":               "app-header-dropdown",
    "app.AppHeader.MenuDropdown.playlistsButton":            "app-header-dropdown",
    "app.AppHeader.MenuDropdown.bookmarksButton":            "app-header-dropdown",
    "app.AppHeader.MenuDropdown.genresButton":               "app-header-dropdown",
    "app.AppHeader.MenuDropdown.artistsButton":              "app-header-dropdown",
    "app.AppHeader.MenuDropdown.CategoryDropdown.activator": "app-header-dropdown",
    "app.AppHeader.MenuDropdown.BrandDropdown.activator":    "app-header-dropdown",
    "app.AppHeader.MenuDropdown.profileButton":              "app-header-dropdown",
    "app.AppHeader.MenuDropdown.privacyButton":              "app-header-dropdown",
    "app.AppHeader.MenuDropdown.cookiePreferencesButton":    "app-header-dropdown",
    "app.AppHeader.MenuDropdown.faqButton":                  "app-header-dropdown",
    "app.AppHeader.MenuDropdown.contactButton":              "app-header-dropdown",
    "app.AppHeader.MenuDropdown.logoutButton":               "app-header-dropdown",

    // Artist Page
    // --------------------------------

    "app.ArtistPage.HeaderContent.MediaButtons.playPauseNavButton": "ghost-green-round-large",
    "app.ArtistPage.HeaderContent.MediaButtons.bookmarkButton":     "ghost-white",

    "app.ArtistPage.HeaderContent.ActionButtons.bookmarkButton": "icon-white",
    "app.ArtistPage.HeaderContent.ActionButtons.followButton":   "icon-white",
    "app.ArtistPage.HeaderContent.ActionButtons.shareButton":    "icon-white",

    "app.ArtistPage.TabBar.tab": "ghost-tab-white",

    "app.ArtistPage.PlaylistItem.infoButton":     "icon-white-darker",
    "app.ArtistPage.PlaylistItem.bookmarkButton": "icon-white-darker",
    "app.ArtistPage.PlaylistItem.shareButton":    "icon-white-darker",

    // Home Page
    // --------------------------------

    "app.HomePage.HeaderContent.ctaButton":   "ghost-white",
    "app.HomePage.HeaderContent.shareButton": "icon-white",

    "app.HomePage.TabBar.tab": "ghost-tab-white",

    // Playlist Page
    // --------------------------------

    "app.PlaylistPage.HeaderContent.MediaButtons.playPauseNavButton": "ghost-green-round-large",
    "app.PlaylistPage.HeaderContent.MediaButtons.bookmarkButton":     "ghost-white",

    "app.PlaylistPage.HeaderContent.ActionButtons.bookmarkButton": "icon-white",
    "app.PlaylistPage.HeaderContent.ActionButtons.shareButton":    "icon-white",


    "app.PlaylistPage.PlaylistItem.infoButton":     "icon-white-darker",
    "app.PlaylistPage.PlaylistItem.bookmarkButton": "icon-white-darker",
    "app.PlaylistPage.PlaylistItem.shareButton":    "icon-white-darker",

    // Media Details Popup
    // --------------------------------

    "app.MediaDetailPopup.playMediaOverlay": "play-icon-overlay-white",
    "app.MediaDetailPopup.closeButton":      "close-popup-white",
    "app.MediaDetailPopup.backButton":       "icon-white",
    "app.MediaDetailPopup.playMediaButton":  "ghost-green-round-large",
    "app.MediaDetailPopup.bookmarkButton1":  "ghost-white",
    "app.MediaDetailPopup.bookmarkButton2":  "icon-white",
    "app.MediaDetailPopup.followButton":     "icon-white",
    "app.MediaDetailPopup.shareButton":      "icon-white",
    "app.MediaDetailPopup.TabBar.tab":       "ghost-tab-white",

    // UI > LargeMediaHeader
    // --------------------------------

    "app.ui.LargeMediaHeader.playMediaOverlay": "play-icon-overlay-white",
    "app.ui.LargeMediaHeader.playMediaButton":  "ghost-green-round-large",
    "app.ui.LargeMediaHeader.signUpButton":     "ghost-white",
    "app.ui.LargeMediaHeader.bookmarkButton1":  "ghost-white",
    "app.ui.LargeMediaHeader.bookmarkButton2":  "icon-white",
    "app.ui.LargeMediaHeader.followButton":     "icon-white",
    "app.ui.LargeMediaHeader.shareButton":      "icon-white",
    "app.ui.LargeMediaHeader.TabBar.tab":       "ghost-tab-white",

    // Sharing
    // --------------------------------

    "app.Sharing.ShareButton":                     "icon-white",
    "app.Sharing.SharePopup.inContentCloseButton": "icon-white",
    "app.Sharing.SharePopup.shareButton":          "social",
    "app.Sharing.SharePopup.copyButton":           "input-white"
};
